<template>
  <div :style="imgStyle"><div v-if="cover" :style="coverStyle"></div></div>
</template>

<script>
  export default {
    props:['img', 'circle', 'height', 'square', 'radius', 'cover', 'opacity'],
    data () {
      return {}
    },
    computed: {
      imgStyle() {
        var style = 'position:relative;background-size:cover;background-position:center;background-repeat:no-repeat;background-image:url('+ this.image(this.img) + ');height:' + this.height +'px;';

        if(this.radius > 0)
          style += 'border-radius:' + this.radius + 'px;';

        if(this.circle) {
          style += 'width:' + this.height + 'px;border-radius:' + this.height +'px;';
        }

        else if(this.square) {
          style += 'width:' + this.height + 'px;';
        }
        return style;
      },
      coverStyle() {
        var style = 'background-color:rgba(0,0,0,' + this.opacity + ');position:absolute;top:0;left:0;right:0;bottom:0;';
        if(this.radius > 0)
          style += 'border-radius:' + this.radius + 'px;';
        return style;
      }
    }
  }
</script>

<style lang="styl" type="stylus" scoped>
//@import '~assets/css/lp_main'
</style>
